import { useEffect, useState } from 'react';

import useAppNavigator from 'views/rebranded-module/common/hooks/useAppNavigator';
import useErrorsHandler from 'views/rebranded-module/common/hooks/useErrorsHandler';
import axios, { API } from 'lib/config/axios';
import useHandleDetectSlugsError from 'views/common/hooks/useHandleDetectSlugsError';
import { setSupressNavigationLoader } from 'redux/features/ui-slice';
import { useDispatch } from 'react-redux';

const useDetectSlugsCSR = (
  slugTypeSSR,
  slugTypeCSR,
  reqBody,
  path,
  dependencyArr = [],
  custom404Handling = false,
) => {
  const appNavigator = useAppNavigator();
  const handleErrorResponse = useErrorsHandler();
  const dispatch = useDispatch();
  const [handleRoute, setHandleRoute] = useState();
  const [slug, setSlug] = useState(slugTypeSSR);
  const [slugRes, setSlugRes] = useState(slugTypeSSR);
  const [loadingSLug, setLoadingSLug] = useState(
    !!appNavigator.query.slug && !slugTypeSSR,
  );
  const [handleNoSlug, handleNewSlug] = useHandleDetectSlugsError();
  const handleSlugTypeChange = (slugData) => {
    setSlug(slugData);
    setSlugRes(slugData);
    setHandleRoute(true);
  };

  const detectSlugs = () => {
    setLoadingSLug(true);
    axios
      .post(API.detectSlugs, {
        ...reqBody,
      })
      .then((res) => {
        setSlugRes(res.data);
        const errorSlug = handleNoSlug(res.data.slugs);
        if (errorSlug) {
          if (!custom404Handling) handleErrorResponse({ response: { status: 404 } }, false);
        }
        const newPath = handleNewSlug(res.data.slugs, path);
        if (!newPath && !errorSlug) {
          setSlug(res.data);
        }
        setLoadingSLug(false);
      })
      .catch((error) => {
        handleErrorResponse(error, false);
      });
  };

  useEffect(() => {
    dispatch(setSupressNavigationLoader(false));
    if (slugTypeCSR && !slugTypeSSR) {
      if (handleRoute) {
        setHandleRoute(false);
      } else {
        detectSlugs();
      }
    } else {
      setSlug(slugTypeSSR);
      setSlugRes(slugTypeSSR);
    }
  }, dependencyArr);
  return [slug, loadingSLug, handleSlugTypeChange, slugRes];
};

export default useDetectSlugsCSR;
